import { IconsProps } from '@/types/shared'

const ManagementEfficiencyIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {/* Gear/Settings icon for management efficiency */}
                <circle cx="12" cy="12" r="3" />
                <path d="M12 1v6m0 6v6m6-11h-6m-6 0h6" />
                <path d="M19.07 4.93l-4.24 4.24m-5.66 0L4.93 4.93m14.14 14.14l-4.24-4.24m-5.66 0l-4.24 4.24" />
            </svg>
        </div>
    )
}

export default ManagementEfficiencyIcons
